import React, { useEffect } from "react";
import Lenis from "lenis";
import { useContent } from "@/content";
import Hero from "@/sections/Hero";
import Experience from "@/sections/Experience";
import Services from "@/sections/Services";
import NightDinner from "@/sections/NightDinner";
import Vehicle from "@/sections/Vehicle";
import Gallery from "@/sections/Gallery";
import Wedding from "@/sections/Wedding";
import Conditions from "@/sections/Conditions";
import ContactSection from "@/sections/ContactSection";
import { Monogram } from "@/components/Monogram";

export default function Home() {
  const { content } = useContent();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  if (!content) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-[#0A0A0C]">
        <div className="animate-pulse">
          <Monogram size={56} />
        </div>
        <p className="eyebrow">OBSIDIAN</p>
      </div>
    );
  }

  return (
    <main data-testid="home-page">
      <Hero />
      <Experience />
      <Services />
      <NightDinner />
      <Vehicle />
      <Conditions />
      <Gallery />
      <Wedding />
      <ContactSection />
    </main>
  );
}
